import type { Interval } from 'date-fns'
import { eachDayOfInterval } from 'date-fns'

export function isCalendarIntervalDisabled(interval: Interval, disabledDate?: (date: Date) => boolean) {
  return Boolean(disabledDate && eachDayOfInterval(interval).every(disabledDate))
}
